import React from 'react';
import styled from 'styled-components';
import InboxClass from './components/Inbox.js';
import SettingsClass from './components/Settings.js';
import editProfile from './editProfile';
import { Link } from 'react-router-dom'

const StyledUser = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: left;
    background-color: #f5f5f5;
    padding: 40px 40px;
    border-radius: 10px;  
    margin: 40px 0px;
    position: relative;
    div.photoAndName{
        display: flex; 
        flex-direction: row; 
        align-items: center;
        margin-bottom: 20px; 
        div.editName{
            display: flex;
            flex-direction: column;
            margin-left: 32px; 
        }
        
    }

    div.editInfo{
        display: flex; 
        flex-direction: row; 
        margin-top: 12px; 
        width: 100%; 
        @media (max-width: 738px) {
            flex-direction: column;
        }
        div#phoneNumber{
            @media (max-width: 738px) {
                margin-top: 20px; 
            }
        }
    }
    
    p{
        font-weight: bold;
        margin-bottom: 0px;
    }
    div.alignTop{
        display: flex; 
        flex-direction: row; 
        justify-content: space-between; 
        align-items: flex-start; 
    }
`
const OtherInfo = styled.div`
    display: flex; 
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin: 24px 0px 0px 0px; 
    p{
        margin-bottom: 0px; 
    }
`
const DoctorInfo = styled.div`
    display: flex; 
    flex-direction: column;
    margin-right: 40px; 
`
const HospitalInfo =styled.div``


const Avatar = styled.div`
    align-self: flex-start;    
    width: 120px; 
    height: 120px; 
    border-radius: 100px;
    background-image: url(${props => props.img});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`

const EditButton = styled.button`
    width: fit-content; 
    padding: 12px 24px; 
    border-radius: 6px; 
    background-color: #377879;
    color: #fff; 
    font-weight: bold;
    position: absolute;
    top: 0; 
    right: 0;
    margin: 20px 20px 0px 0px; 
    @media (max-width: 738px) {
        top: auto;
        bottom: 0; 
        left: 0;
        width: 100%; 
        margin: auto; 
    }
`

const Editable = styled.div`
    margin: 0px 0px 0px 0px;
`

const Content = styled.div`
    // display: flex; 
    // flex-direction: column;
    // align-items: center;
    max-width: 800px; 
`

class User extends React.Component{
    render(){
        return(
            <StyledUser>
                <div className="alignTop">
                    <div className='photoAndName'>
                        <div><Avatar img= {require('./img/jane_pearson.jpg')}/></div>
                        <div className='editName'>
                            <p>Patient name</p>
                            <Editable>Jane Pearson</Editable>
                        </div>
                    </div>
                </div>
                <div className='editInfo'>
                    <div style={{marginRight: 120 + 'px'}}>
                        <p>Email address</p>
                        <Editable>jane.pearson@gmail.com</Editable>
                    </div>
                    <div id="phoneNumber">
                        <p>Phone number</p>
                        <Editable>T: (123) 456-7890</Editable>
                    </div>
                </div>
                <Link>
                    <EditButton>Edit</EditButton>
                </Link>
            </StyledUser>
        )
    }
}

export const Profile = () => (
    <div className ="custom-container">
        <h2>Profile</h2>
        <Content>
            <User/>
            <OtherInfo>
                <DoctorInfo>
                    <h4>Doctor</h4>
                    <p>Mary Fields, M.D.</p>
                    <p>T: (941) 943-584</p>
                </DoctorInfo>
                <HospitalInfo>
                    <h4>Hospital</h4>
                    <p>Cancer Institute of New Jersey</p>
                    <p>195 Little Albany St</p>
                    <p>New Brunswick, NJ 08901</p>
                    <p>T: (732) 235-8515</p>
                </HospitalInfo>
            </OtherInfo>
            <h3 className='mt-4'>Settings</h3>
            <SettingsClass/>
            <h3 className='mt-4'>Inbox</h3>
            <InboxClass/>
        </Content>
    </div>
  )